import { skipToken } from "@reduxjs/toolkit/query";

import { DataTable } from "components/Datatable";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";

import { useGetStoreBankAccountStoreViewQuery } from "@/services/store-bank-account";
import type { StoreAccountView } from "@/services/dtos/store-bank-account.dto";

import {
  STORE_VIEW_COLUMNS,
  STORE_VIEW_EMPTY_MESSAGE,
  STORE_VIEW_MODAL_DESCRIPTION,
  STORE_VIEW_MODAL_TITLE,
} from "./types";

export interface StoreViewModalProps {
  open: boolean;
  storeCode: number | null;
  onClose: () => void;
}

function resolveStoreViewQueryArg(
  open: boolean,
  storeCode: number | null,
): number | typeof skipToken {
  if (!open || storeCode === null) return skipToken;
  return storeCode;
}

export function StoreViewModal({
  open,
  storeCode,
  onClose,
}: StoreViewModalProps) {
  const { data: accounts, isFetching } = useGetStoreBankAccountStoreViewQuery(
    resolveStoreViewQueryArg(open, storeCode),
  );

  const handleOpenChange = (next: boolean): void => {
    if (next) return;
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>{STORE_VIEW_MODAL_TITLE}</DialogTitle>
          <DialogDescription>
            {STORE_VIEW_MODAL_DESCRIPTION}
          </DialogDescription>
        </DialogHeader>

        <DataTable<StoreAccountView, unknown>
          columns={STORE_VIEW_COLUMNS}
          data={accounts ?? []}
          isLoading={isFetching}
          emptyMessage={STORE_VIEW_EMPTY_MESSAGE}
        />
      </DialogContent>
    </Dialog>
  );
}
